import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  // ASSETS_BASE_URL,
  defaultRemoteConfig,
  defaultLottieData,
  ROW_TYPE_DATA,
} from "../../AppConstants/Constants";
import { BackstageManager } from "../../Managers/Backstage";
import { UserContext } from "../UserContext/UserContextProvider";
import { BACKSTAGE_COLLECTION } from "../../AppConstants/CollectionConstants";
import { database, firestore, remoteConfig } from "../../firebase/firebase";
import { useLocation } from "react-router-dom";
import {
  EMPLOYEE_DASHBOARD_ROUTE,
  // EMPLOYEE_DASHBOARD_TEAM_ROUTE,
} from "../../AppConstants/Routes";
import { BACKSTAGE_PATHS } from "../../AppConstants/RealtimeDB";

export const ConstantDataContext = createContext();

const showModalInitialState = {
  visible: false,
  data: null,
  sectionId: null,
  sectionName: "",
};

const SpeakerPage_Default = {
  bestShows: [],
  speciality: [],
};

const defaultDocflixConstant = {
  videos: {
    skipBtnText: "Skip",
    outroBtnText: "Skip",
    skipBtnToggle: false,
    outroBtnToggle: false,

    latestTag: {
      show: false,
      text: "New",
    },
  },
};

const defaultBanners = {
  webinarBanner: {
    type: "",
    bannerLottieMobile: "",
    bannerLottieDesktop: "",
    imageSlides: [],
  },
};

export default function ConstantDataContextProvider(props) {
  const [TagsData, setTagsData] = useState({});
  const [showSearch, setShowSearch] = useState(false);
  const [showUserFeedback, setShowUserFeedback] = useState(false);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [selectedShow, setSelectedShow] = useState("");
  const [anouncementBar, setAnouncementBar] = useState({});
  const [speakerPage, setSpeakerPage] = useState(SpeakerPage_Default);
  const [featuredSectiondata, setFeaturedSectionData] = useState(null);
  const [seasonModalData, setSeasonModalData] = useState(showModalInitialState);
  const [allWatchLater, setAllWatchLater] = useState([]);
  const [isAnalyticsAvailable, setIsAnalyticsAvailable] = useState(false);
  const [privateSectiondata, setPrivateSectionData] = useState(null);
  const [newReleasesData, setNewReleasesData] = useState(null);
  const [banners, setBanners] = useState(defaultBanners);
  const [globalDocflixConstant, setGlobalDocflixConstant] = useState(
    defaultDocflixConstant
  );
  const [remoteConfigData, setRemoteConfigData] = useState({
    ...defaultRemoteConfig,
    ...defaultLottieData,
  });

  const [selectedBreadCrumb, setSelectedBreadCrumb] = useState({
    tabs: ["Analytics Center"],
    activeTab: { tab: "Analytics Center" },
  });
  const userInterected = useRef(false);
  const { user, userBasicDetails } = useContext(UserContext);
  const location = useLocation();

  useEffect(() => {
    getRemoteConfig();
    getAnnouncementData();

    const userIntercted = () => {
      userInterected.current = true;
    };

    const interactionEvents = ["click", "keydown", "touchstart"];
    interactionEvents.forEach((event) =>
      document.addEventListener(event, userIntercted)
    );

    return () => {
      interactionEvents.forEach((event) =>
        document.removeEventListener(event, userIntercted)
      );
    };
  }, []);

  const getRemoteConfig = async () => {
    try {
      let fetchedRemotely = await remoteConfig.fetchAndActivate();

      let _remoteConfigs = remoteConfig.getAll();
      let _remoteConfigsData = {};

      Object.keys(_remoteConfigs).forEach((key) => {
        _remoteConfigsData[key] = JSON.parse(_remoteConfigs[key]._value);
      });

      setRemoteConfigData((prev) => ({ ...prev, ..._remoteConfigsData }));

      if (fetchedRemotely) {
        console.log("Configs were retrieved from the backend and activated.");
      } else {
        console.log(
          "No configs were fetched from the backend, and the local configs were already activated"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location?.pathname) {
      let pathsArray = location?.pathname.split("/").filter((i) => i && i);
      let obj = {
        tabs: [],
        activeTab: { tab: "" },
      };

      for (let i = 0; i < pathsArray.length; i++) {
        switch (`/${pathsArray[i]}`) {
          case EMPLOYEE_DASHBOARD_ROUTE:
            obj["tabs"].push({
              tab: "Analytics Center",
              id: EMPLOYEE_DASHBOARD_ROUTE,
            });
            break;
          case "/teams":
            obj["tabs"].push({ tab: "Teams", id: "/teams" });
            break;
          case "/doctors":
            obj["tabs"].push({ tab: "Doctors", id: "/doctors" });
            break;
          case "/employee":
            obj["tabs"] = [
              ...obj["tabs"],
              { tab: "Teams", id: "/teams" },
              { tab: "Employee", id: "/employee" },
            ];
            break;
          case "/fieldAgent":
            obj["tabs"] = [
              ...obj["tabs"],
              { tab: "Teams", id: "/teams" },
              { tab: "Field Agent", id: "/fieldAgent" },
            ];
            break;
          default:
            break;
        }
      }
      let _activeTab = obj["tabs"][obj["tabs"].length - 1];
      obj["activeTab"] = _activeTab;
      updateEmployeeBreadCrumb(obj);
    }
  }, [location]);

  useEffect(() => {
    if (user) {
      BackstageManager.getTagsData()
        .then((_data) => {
          if (!_data) {
            // setTagsData(TagsData);
            return;
          }
          let _obj_data = {};
          _data.sort((a, b) => a.order - b.order);
          _data.forEach((element) => {
            _obj_data[element.sectionId] = element;
          });
          setTagsData(_obj_data);
        })
        .catch((err) => {
          console.error(err);
          setTagsData(TagsData);
        });

      BackstageManager.getSpeakerPageData()
        .then((_data) => {
          if (!_data) {
            setSpeakerPage(SpeakerPage_Default);
            return;
          }
          setSpeakerPage(_data);
        })
        .catch((err) => {
          console.error(err);
          setSpeakerPage(SpeakerPage_Default);
        });
    }
    // else{
    //     sessionStorage.removeItem("announcementShow");
    //     setShowAnnouncement(true);
    // }
    BackstageManager.getDocflixConstant()
      .then((_data) => {
        if (!_data) {
          setGlobalDocflixConstant(defaultDocflixConstant);
          return;
        }
        setGlobalDocflixConstant(_data);
      })
      .catch((err) => {
        console.error(err);
        setGlobalDocflixConstant(defaultDocflixConstant);
      });
  }, [user]);

  // useEffect(() => {
  //   if (userBasicDetails && userBasicDetails.phoneNumber) {
  //     checkAnalyticsAvailable(userBasicDetails.phoneNumber);
  //   }
  // }, [userBasicDetails]);

  const handleSeasonModalClose = () => {
    setSeasonModalData(showModalInitialState);
  };

  const handleSeasonModalOpen = (sectionId, data) => {
    setSeasonModalData({
      visible: true,
      data: data,
      sectionId: sectionId,
      sectionName: ROW_TYPE_DATA[sectionId]?.heading || "",
    });
  };

  const getFeaturedSectionData = async () => {
    try {
      const docRef = await firestore
        .collection(BACKSTAGE_COLLECTION)
        .doc("featuredSection")
        .get();
      if (docRef.exists) {
        setFeaturedSectionData(docRef.data()?.["dataWithSpeciality"]);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAnnouncementData = async () => {
    try {
      const docRef = await firestore
        .collection(BACKSTAGE_COLLECTION)
        .doc("anouncementBar")
        .get();
      if (docRef.exists) {
        // setAnouncementBar(docRef.data());
        //filter the announcements which are set as enable
        let announcementData = docRef.data();
        announcementData.data = announcementData.data.filter(item => item.enable);
        setAnouncementBar(announcementData);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  useEffect(() => {

    if (user && anouncementBar) {
      if (anouncementBar.enable) {
        const hasDismissedAnnouncementBar =
          sessionStorage.getItem("announcementShow");
        if (!hasDismissedAnnouncementBar) {
          setShowAnnouncement(true);
        }
      }
    } else if (!user) {
      // USER IS LOGGED OUT
      sessionStorage.removeItem("announcementShow");
    }
  }, [user, anouncementBar]);

  // const checkAnalyticsAvailable = async (number) => {
  //   try {
  //     let unlocked = false;

  //     // let docRef = await database.ref(`FieldAgentsDev/${number}`).once("value");

  //     // if (docRef.exists()) {
  //     //   unlocked = true;
  //     // }

  //     setIsAnalyticsAvailable(unlocked);
  //   } catch (error) {
  //     setIsAnalyticsAvailable(false);
  //     console.error("Error :: ", error);
  //   }
  // };

  const getPrivateSectionData = async () => {
    try {
      const docRef = await firestore
        .collection(BACKSTAGE_COLLECTION)
        .doc("privateVideoSection")
        .get();
      if (docRef.exists) {
        setPrivateSectionData(docRef.data());
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getNewReleaseSectionData = async () => {
    try {
      const docRef = await firestore
        .collection(BACKSTAGE_COLLECTION)
        .doc("newReleases")
        .get();

      if (docRef.exists) {
        let _data = docRef.data();
        let newData = _data.data.filter((item) => item.enable);
        _data.data = newData;
        setNewReleasesData(_data);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getBannerConfig = async () => {
    try {
      const docRef = await database
        .ref(BACKSTAGE_PATHS.BANNERS)
        .once("value");

      if (docRef.exists()) {
        setBanners({
          ...docRef.val(),
        });
      }
    } catch (error) {
      console.error("Error fetching webinarBannerConfig:", error);
    }
  };

  const updateEmployeeBreadCrumb = (data) => {
    setSelectedBreadCrumb((prev) => {
      return { ...prev, ...data };
    });
  };

  const handleOpenUserFeedbackModal = useCallback(() => {
    setShowUserFeedback(true);
  }, []);
  const handleCloseUserFeedbackModal = useCallback(() => {
    setShowUserFeedback(false);
  }, []);
  return (
    <ConstantDataContext.Provider
      value={{
        TagsData,
        speakerPage,
        remoteConfigData,
        anouncementBar,
        globalDocflixConstant,
        seasonModalData,
        handleSeasonModalClose,
        handleSeasonModalOpen,
        featuredSectiondata,
        getFeaturedSectionData,
        getNewReleaseSectionData,
        showSearch,
        setShowSearch,
        selectedShow,
        setSelectedShow,
        allWatchLater,
        setAllWatchLater,
        getPrivateSectionData,
        privateSectiondata,
        newReleasesData,
        updateEmployeeBreadCrumb,
        selectedBreadCrumb,
        isAnalyticsAvailable,
        showAnnouncement,
        setShowAnnouncement,
        handleCloseUserFeedbackModal,
        handleOpenUserFeedbackModal,
        showUserFeedback,
        getBannerConfig,
        banners,
        userInterected: userInterected.current,
      }}
    >
      {props.children}
    </ConstantDataContext.Provider>
  );
}
